import React, { createContext, useContext, useState, useEffect } from 'react';

import { Dependent } from 'types';

type DependentContextType = {
  value?: Dependent;
  setValue: (value: Dependent) => void;
};

// eslint-disable-next-line
const Context = createContext<DependentContextType>({ setValue: () => {} });

export const DependentDetailProvider: React.FC = ({ children }) => {
  const [value, setValue] = useState<Dependent>();
  return <Context.Provider value={{ value, setValue }}>{children}</Context.Provider>;
};

export const useDependentDetail = () => useContext(Context);
